import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartnerDataService {

  constructor(private http: HttpClient) { }

  //url = environment.serverAPI4 + "/api/ig/partnerdata";
  url = environment.serverAPI4 + "/api/partnerdata";

  getPartnerPage(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

}
